// Shared page chrome for every Chord Craft room — "workshop at night": a
// warm dark shell with a wordmark, room-nav pills, and a footer link back to
// Silly Projects. Every room page wraps its content in this. Presentational
// only; each room owns its own state and lib calls.
//
// Props: { room: 'home'|'palette'|'gym'|'slither'|'loop', title, subtitle?, children }

import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

// Literal class strings per room (not composed via template interpolation)
// so Tailwind's JIT scanner always picks them up from this file alone.
const ROOMS = [
  {
    id: "palette",
    label: "Palette",
    path: "/chord-craft/palette",
    activeClass: "bg-fuchsia-400 text-stone-950",
  },
  {
    id: "gym",
    label: "Gym",
    path: "/chord-craft/gym",
    activeClass: "bg-amber-400 text-stone-950",
  },
  {
    id: "slither",
    label: "Slither",
    path: "/chord-craft/slither",
    activeClass: "bg-emerald-400 text-stone-950",
  },
  {
    id: "loop",
    label: "Loop",
    path: "/chord-craft/loop",
    activeClass: "bg-sky-400 text-stone-950",
  },
];

export default function CraftShell({ room, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-300">
      <header className="border-b border-stone-800/80">
        <div className="max-w-5xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-3">
          <Link
            to="/chord-craft"
            className="font-serif text-xl tracking-wide text-amber-50"
          >
            Chord Craft
          </Link>
          <nav className="flex flex-wrap gap-2" aria-label="Chord Craft rooms">
            {ROOMS.map((r) => {
              const isActive = room === r.id;
              return (
                <Link
                  key={r.id}
                  to={r.path}
                  className={cn(
                    "rounded-full px-3 py-1 text-sm font-medium transition-colors",
                    isActive
                      ? r.activeClass
                      : "bg-stone-800 text-stone-300 hover:bg-stone-700"
                  )}
                >
                  {r.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 pb-16">
        <div className="pt-8 pb-6">
          <h1 className="font-serif text-3xl sm:text-4xl text-amber-50">{title}</h1>
          {subtitle && <p className="mt-2 text-stone-400 max-w-2xl">{subtitle}</p>}
        </div>
        {children}
      </main>

      <footer className="max-w-5xl mx-auto px-4 pb-10 text-center">
        <Link
          to="/sillyprojects"
          className="text-xs text-stone-600 hover:text-stone-400 underline decoration-dotted underline-offset-4"
        >
          part of keyoni&apos;s silly projects
        </Link>
      </footer>
    </div>
  );
}
